import type { Reducer } from 'redux';
import ErrorRecord from '~/data/ErrorRecord';
import type { GatewaysActions } from './types/actions.types';
import GatewaysRecord, { createGatewayRecordList } from './data/GatewaysRecord';
import GatewaysContainerConstants from './constants';

function getInitialState() {
  return new GatewaysRecord();
}

const defaultState = getInitialState();

const reducer: Reducer<GatewaysRecord, GatewaysActions> = (state = defaultState, action) => {
  switch (action.type) {
    case GatewaysContainerConstants.GET_GATEWAYS_REQUEST:
      return state.merge({
        isLoading: true,
        forceReload: false,
        error: undefined,
      });

    case GatewaysContainerConstants.GET_GATEWAYS_REQUEST_SUCCESS:
      return state
        .set('stationaryGateways', createGatewayRecordList(action.response.STATIONARY || []))
        .set('mobileGateways', createGatewayRecordList(action.response.MOBILE || []))
        .merge({ isLoading: false });

    case GatewaysContainerConstants.GET_GATEWAYS_REQUEST_ERROR:
      return state.merge({
        isLoading: false,
        error: new ErrorRecord(action.error),
      });

    case GatewaysContainerConstants.REMOVE_GATEWAY_REQUEST:
      return state.updateGateway(action.payload.gatewayId, (gateway) => {
        return gateway.set('isDeleting', true);
      });

    case GatewaysContainerConstants.REMOVE_GATEWAY_REQUEST_SUCCESS:
      return state.removeGatewayFromList(action.payload.gatewayId);

    case GatewaysContainerConstants.REMOVE_GATEWAY_REQUEST_ERROR:
      return state
        .merge({
          removeGatewayError: new ErrorRecord(action.error),
        })
        .updateGateway(action.payload.gatewayId, (gateway) => {
          return gateway.set('isDeleting', false);
        });

    case GatewaysContainerConstants.RESET_GATEWAY_ERROR:
      return state.merge({ removeGatewayError: undefined });

    default:
      return state;
  }
};

export default reducer;
